import ComplementoIntereses from './summary/ComplementoInteresesResumen';
import ComplementoDividendos from './summary/ComplementoDividendosResumen';
import ComplementoPlanesderetiro from './summary/ComplementoPlanesderetiroResumen';
import ComplementoPagosaextranjeros from './summary/ComplementoPagosaextranjerosResumen';
import ComplementoSectorFinancieroResumen from './summary/ComplementoSectorFinancieroResumen';
import ComplementoEnajenaciondeAcciones from './summary/ComplementoEnajenaciondeAccionesResumen';
import ComplementoInteresesHipotecarios from './summary/ComplementoInteresesHipotecariosResumen';
import ComplementoOperacionesconderivados from './summary/ComplementoOperacionesconderivadosResumen';
import ComplementoArrendamientoenfideicomiso from './summary/ComplementoArrendamientoenfideicomisoResumen';
import ComplementoPlataformasTecnologicasResumen from './summary/ComplementoPlataformasTecnologicasResumen';
import { ComplementoFideicomisoNoEmpresarialResumen } from './summary';

const complementosResumenList = {
  Arrendamientoenfideicomiso: ComplementoArrendamientoenfideicomiso,
  Dividendos: ComplementoDividendos,
  EnajenaciondeAcciones: ComplementoEnajenaciondeAcciones,
  Intereses: ComplementoIntereses,
  Intereseshipotecarios: ComplementoInteresesHipotecarios,
  Operacionesconderivados: ComplementoOperacionesconderivados,
  Pagosaextranjeros: ComplementoPagosaextranjeros,
  Planesderetiro: ComplementoPlanesderetiro,
  ServiciosPlataformasTecnologicas: ComplementoPlataformasTecnologicasResumen,
  SectorFinanciero: ComplementoSectorFinancieroResumen,
  Fideicomisonoempresarial: ComplementoFideicomisoNoEmpresarialResumen,
};

export default complementosResumenList;
